import { useCallback, useEffect } from 'react';
import { setCreateAlert } from 'redux/reducers/meteorologyFieldsGroupLocationFeedbackReducer';
import { store } from 'redux/store';
import { ResponseError } from 'services/api/base';
import { useSaveFieldsLocationMutation } from 'services/api/Meteorology/Fields/TrackingForecast/Register';

export default function useSaveLocation() {
  const [trigger, { data, isLoading, error }] = useSaveFieldsLocationMutation();
  const saveLocation = useCallback((groupId, name, latitude, longitude, cityId) => {
    trigger({
      groupId, name, latitude, longitude, cityId,
    });
  }, [trigger]);

  useEffect(() => {
    if (error) {
      const responseError = error as ResponseError;
      store.dispatch(setCreateAlert({
        title: responseError.data || 'Erro',
        message: responseError.description || 'Ocorreu um erro ao salvar o local.',
        variant: 'danger',
      }));
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      store.dispatch(setCreateAlert({
        title: data.title || 'Sucesso',
        message: data.message || 'Local criado com sucesso.',
        variant: 'success',
      }));
    }
  }, [data]);

  return {
    saveLocation,
    isSavingLocation: isLoading,
  };
}
